import AWSFargate from './AWSFargate'

export default AWSFargate
